import { useQuery } from '@tanstack/react-query';
import { http } from 'services/http';
import type { TClientUserRes } from 'api/swagger';
import { CLIENT_APP_CLIENT_USERS_MY } from 'client-app/api/query-keys';

export const useGetMyClientUser = (enabled: boolean = true) => {
  return useQuery<TClientUserRes>({
    queryKey: [CLIENT_APP_CLIENT_USERS_MY],
    queryFn: async () => {
      const { data } = await http.get<TClientUserRes>('client-office/v1/my');
      return data;
    },
    enabled,
    retry: 2,
    refetchOnWindowFocus: false,
    cacheTime: 0,
  });
};
